export enum STORE_TYPE {
    RX = "RX",
    NON_RX = "NON_RX",
}
